var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, isRef as _isRef, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-3a1b3ba2"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "content-wrapper" };
var _hoisted_2 = { class: "column column-1" };
var _hoisted_3 = { class: "assignment-table-container margin-wrapper" };
var _hoisted_4 = { class: "margin-wrapper" };
var _hoisted_5 = { class: "column column-2" };
import { NConfigProvider, NNotificationProvider } from 'naive-ui';
import { computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import naiveUiConfig from '../../config/naive-theme-config.json';
import { themeConfigAddendum } from '../../config/naive-ui';
import { key } from '../../store/index';
import useTimer from '../composables/useTimer';
import AssignedTransportRequestsTableRow from './assignmentTable/rowTypes/AssignedTransportRequestsTableRow.vue';
import AssignmentSubHeader from './AssignmentSubHeader.vue';
import AssignmentHeader from './AssignmentHeader.vue';
import AssignmentTable from './assignmentTable/AssignmentTable.vue';
import AssignmentMapView from './map/AssignmentMapView.vue';
import AllocatedTransportRequestsTableRow from './assignmentTable/rowTypes/AllocatedTransportRequestsTableRow.vue';
import AwaitingTransportRequestsTableRow from './assignmentTable/rowTypes/AwaitingTransportRequestsTableRow.vue';
import OnBoardTransportRequestsTableRow from './assignmentTable/rowTypes/OnBoardTransportRequestsTableRow.vue';
import PiloteMultiSelect from '../generic/select/PiloteMultiSelect.vue';
import PiloteProgress from '../generic/progress/PiloteProgress.vue';
import useTransportStatusFilter from "../composables/useTransportStatusFilter";
var TRANSPORT_POLLING_RATE_IN_MILLISECONDS = 30000;
var hiddenStatusesKey = "assignmentPageHiddenStatuses";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AssignmentPage',
    setup: function (__props) {
        var _this = this;
        var naiveThemeConfig = __assign(__assign({}, naiveUiConfig), themeConfigAddendum);
        var store = useStore(key);
        var t = useI18n({ useScope: 'global' }).t;
        var getTeamById = computed(function () { return store.getters['teams/getTeamById']; });
        var assignmentTableHeaderLabel = [
            t('assignment.table.route'),
            t('assignment.table.awaitingTime'),
            t('assignment.table.distanceDuration'),
            t('assignment.table.originAndDestination'),
            t('assignment.table.team'),
            t('assignment.table.passengers_seatbelts')
        ];
        var value = localStorage.getItem(hiddenStatusesKey);
        var initialStatuses = value ? JSON.parse(value) : [];
        var _a = useTransportStatusFilter(initialStatuses), hiddenStatuses = _a.hiddenStatuses, options = _a.options, allocatedIsDisplayed = _a.allocatedIsDisplayed, onBoardIsDisplayed = _a.onBoardIsDisplayed;
        var updateHiddenStatuses = function (value) {
            localStorage.setItem(hiddenStatusesKey, JSON.stringify(value));
            hiddenStatuses.value = value;
        };
        var timer = useTimer(TRANSPORT_POLLING_RATE_IN_MILLISECONDS, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.dispatch('transports/fetch')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, store.dispatch('teams/fetch')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.dispatch('teams/fetch')];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, store.dispatch('transports/fetch')];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () {
            store.dispatch('assignmentPage/unfocusTransport');
        });
        var isFocused = function (transport) {
            var currentlyFocusedTransportId = store.state.assignmentPage.focusedTransportId;
            return currentlyFocusedTransportId === transport.transportRequestId;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": naiveThemeConfig }, {
                default: _withCtx(function () { return [
                    _createVNode(_unref(NNotificationProvider), null, {
                        default: _withCtx(function () { return [
                            _createVNode(AssignmentHeader, {
                                class: "header margin-wrapper",
                                timer: _unref(timer)
                            }, null, 8 /* PROPS */, ["timer"]),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(PiloteProgress, {
                                            class: "assignment-table-timer",
                                            percentage: _unref(timer).percentage.value
                                        }, null, 8 /* PROPS */, ["percentage"]),
                                        _createVNode(AssignmentSubHeader, {
                                            class: "assignment-subheader",
                                            label: _unref(t)('assignment.awaitingTransportRequests')
                                        }, null, 8 /* PROPS */, ["label"]),
                                        _createVNode(AssignmentTable, {
                                            "header-labels": assignmentTableHeaderLabel,
                                            class: "awaiting-assignment-table",
                                            "table-format": "compact",
                                            "message-when-empty": _unref(t)('assignment.table.assignmentTableIsEmpty'),
                                            "show-team-column": false,
                                            "show-passengers-column": true
                                        }, {
                                            default: _withCtx(function () { return [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters['transports/pendingByDescendingWaitingTime'], function (transport) {
                                                    return (_openBlock(), _createBlock(AwaitingTransportRequestsTableRow, {
                                                        key: transport.id,
                                                        transport: transport,
                                                        "show-action-buttons": false,
                                                        onClick: function () { return _unref(store).dispatch('assignmentPage/toggleFocusedTransportId', transport.transportRequestId); },
                                                        class: _normalizeClass({ 'basic-row': true, 'focused-row': isFocused(transport) })
                                                    }, null, 8 /* PROPS */, ["transport", "onClick", "class"]));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ]; }),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["message-when-empty"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createVNode(PiloteProgress, {
                                            class: "dispatch-table-timer",
                                            percentage: _unref(timer).percentage.value
                                        }, null, 8 /* PROPS */, ["percentage"]),
                                        _createVNode(AssignmentSubHeader, {
                                            class: "assignment-subheader",
                                            label: _unref(t)('assignment.transportRequestsToDispatchAndOnARide')
                                        }, {
                                            default: _withCtx(function () { return [
                                                _createVNode(PiloteMultiSelect, {
                                                    class: "multi-select",
                                                    value: _unref(hiddenStatuses),
                                                    "onUpdate:value": _cache[0] || (_cache[0] = function ($event) { return (_isRef(hiddenStatuses) ? (hiddenStatuses).value = $event : null); }),
                                                    "on-update:value": updateHiddenStatuses,
                                                    options: _unref(options),
                                                    placeholder: _unref(t)('assignment.table.filter.placeholder')
                                                }, null, 8 /* PROPS */, ["value", "options", "placeholder"])
                                            ]; }),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]),
                                        _createVNode(AssignmentTable, {
                                            class: "dispatch-table",
                                            "header-labels": assignmentTableHeaderLabel,
                                            "table-format": "large",
                                            "message-when-empty": _unref(t)('assignment.table.dispatchTableIsEmpty')
                                        }, {
                                            default: _withCtx(function () { return [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).getters['transports/assignedByDescendingWaitingTime'], function (transport) {
                                                    return (_openBlock(), _createBlock(AssignedTransportRequestsTableRow, {
                                                        key: transport.transportRequestId,
                                                        team: getTeamById.value(transport.teamId),
                                                        transport: transport,
                                                        onClick: function () { return _unref(store).dispatch('assignmentPage/toggleFocusedTransportId', transport.transportRequestId); },
                                                        class: _normalizeClass({ 'basic-row': true, 'focused-row': isFocused(transport) })
                                                    }, null, 8 /* PROPS */, ["team", "transport", "onClick", "class"]));
                                                }), 128 /* KEYED_FRAGMENT */)),
                                                (_unref(allocatedIsDisplayed))
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(store).getters['transports/allocatedByDescendingWaitingTime'], function (transport) {
                                                        return (_openBlock(), _createBlock(AllocatedTransportRequestsTableRow, {
                                                            key: transport.transportRequestId,
                                                            team: getTeamById.value(transport.teamId),
                                                            transport: transport,
                                                            onClick: function () { return _unref(store).dispatch('assignmentPage/toggleFocusedTransportId', transport.transportRequestId); },
                                                            class: _normalizeClass({ 'basic-row': true, 'focused-row': isFocused(transport) })
                                                        }, null, 8 /* PROPS */, ["team", "transport", "onClick", "class"]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                    : _createCommentVNode("v-if", true),
                                                (_unref(onBoardIsDisplayed))
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(store).getters['transports/onBoardByDescendingWaitingTime'], function (transport) {
                                                        return (_openBlock(), _createBlock(OnBoardTransportRequestsTableRow, {
                                                            key: transport.transportRequestId,
                                                            team: getTeamById.value(transport.teamId),
                                                            transport: transport,
                                                            onClick: function () { return _unref(store).dispatch('assignmentPage/toggleFocusedTransportId', transport.transportRequestId); },
                                                            class: _normalizeClass({ 'basic-row': true, 'focused-row': isFocused(transport) })
                                                        }, null, 8 /* PROPS */, ["team", "transport", "onClick", "class"]));
                                                    }), 128 /* KEYED_FRAGMENT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]; }),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["message-when-empty"])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _createVNode(PiloteProgress, {
                                        class: "map-timer",
                                        percentage: _unref(timer).percentage.value
                                    }, null, 8 /* PROPS */, ["percentage"]),
                                    _createVNode(AssignmentMapView, {
                                        "positioned-teams": _unref(store).getters['teams/positionedAssignedOrAvailable'],
                                        "unpositioned-teams": _unref(store).getters['teams/unpositionedAssignedOrAvailable'],
                                        "transport-origins": _unref(store).getters['transports/waitingForRide']
                                    }, null, 8 /* PROPS */, ["positioned-teams", "unpositioned-teams", "transport-origins"])
                                ])
                            ])
                        ]; }),
                        _: 1 /* STABLE */
                    })
                ]; }),
                _: 1 /* STABLE */
            }));
        };
    }
});
